// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-control[data-v-28871c1a] {\n  -webkit-box-shadow: 0 2px 2px 1px rgb(0 0 0 / 6%);\n          box-shadow: 0 2px 2px 1px rgb(0 0 0 / 6%);\n  border: none !important;\n  border-radius: 0 !important;\n  height: 31px;\n  padding-left: 1rem;\n  color: #4f565c;\n  background-color: white;\n}\n.form-control[data-v-28871c1a]:focus-visible {\n  outline-offset: 0px;\n  outline: -webkit-focus-ring-color auto 1px;\n}\n", ""]);
// Exports
module.exports = exports;
